var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { routes } from '@lean-body/src/route';
import { checkSameArray, validateDate } from '@lean-body/src/util';
import { UserWeight } from '@lean-body/src/domain';
import { Input, Select, InputButtonTypeRadioButton, InputButtonTypeCheckbox } from '@lean-body/components/atoms';
import { PageLoading, SelectProfilePicture } from '@lean-body/components/organisms';
import { SettingItemKeys } from '@lean-body/components/organisms/setting_menu';
import { FixedFooterUpdateButton, DateSelectForm } from '@lean-body/components/molecules';
import { WeightGoalAchievedDialog } from '../molecules/weight_goal_achieved_dialog';
import { GoalMatchingAssessmentPageQuery } from '../pages/main_goal_matching_assessment';
const { useState, useEffect } = React;
export const ProfileChangeSubsection = ({ classObject, apiClient, tracker, alertPresenter, setItemKey, profile, setProfile, }) => {
    const navigate = useNavigate();
    const [userName, setUserName] = useState(profile.userName);
    const [birthday, setBirthday] = useState(profile.birthday);
    const [gender, setGender] = useState(profile.gender.toString());
    const [prefecture, setPrefecture] = useState(profile.prefecture);
    const [weight, setWeight] = useState(!profile.weight ? '' : profile.weight.toString());
    const [height, setHeight] = useState(!profile.height ? '' : profile.height.toString());
    const [activityLevelType, setActivityLevelType] = useState(profile.activityLevel.id || null);
    const [worries, setWorries] = useState(profile.worriesIdsToString);
    const [interests, setInterests] = useState(profile.interestsIdsToString);
    const [sessionDurationType, setSessionDurationType] = useState(profile.sessionDurationType);
    const [exerciseRoutineType, setExerciseRoutineType] = useState(profile.exerciseRoutineType);
    const [targetBodyPartTagIds, setTargetBodyPartTagIds] = useState(profile.targetBodyPartTagIdsToString);
    const [exerciseRestrictionIds, setExerciseRestrictionIds] = useState(profile.exerciseRestrictionIdsToString);
    const [availableToolIds, setAvailableToolIds] = useState(profile.availableToolIdsToString);
    const [imgSrc, setImgSrc] = useState(profile.pictureSrc);
    const [clipFileSrc, setClipFileSrc] = useState(profile.pictureSrc);
    const [file, setFile] = useState();
    const [genderOptions, setGenderOptions] = useState();
    const [prefectureOptions, setPrefectureOptions] = useState();
    const [activityLevelOptions, setActivityLevelOptions] = useState();
    const [worryOptions, setWorryOptions] = useState();
    const [interestOptions, setInterestOptions] = useState();
    const [sessionDurations, setSessionDurations] = useState([]);
    const [exerciseRoutines, setExerciseRoutines] = useState([]);
    const [exerciseRestrictions, setExerciseRestrictions] = useState([]);
    const [availableTools, setAvailableTools] = useState([]);
    const [partTags, setPartTags] = useState([]);
    const [saveButtonClickable, setSaveButtonClickable] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isShowGoalAchievedDialog, setIsShowGoalAchievedDialog] = React.useState();
    const [isValidateRealtime, setIsValidateRealtime] = React.useState(false);
    const [validationErrorMessages, setValidationErrorMessages] = React.useState({
        userName: '',
        birthday: '',
        gender: '',
        height: '',
        weight: '',
        activityLevelType: '',
        worries: '',
        interests: '',
        sessionDurationType: '',
        exerciseRoutineType: '',
        targetBodyPartTagIds: '',
        exerciseRestrictionIds: '',
        availableToolIds: '',
    });
    const sessionItems = sessionDurations.map((sd) => ({ name: sd.content, value: sd.type }));
    const routineItems = exerciseRoutines.map((er) => ({ name: er.content, value: er.type }));
    const partItems = partTags.map((t) => ({ name: t.name, value: String(t.id) }));
    const restrictionItems = exerciseRestrictions.map((r) => ({ name: r.content, value: String(r.id) }));
    const toolItems = availableTools.map((t) => ({ name: t.content, value: String(t.id) }));
    useEffect(() => {
        Promise.all([
            apiClient.fetchGenders(),
            apiClient.fetchPrefectures(),
            apiClient.fetchActivityLevels(),
            apiClient.fetchWorries(),
            apiClient.fetchInterests(),
            apiClient.fetchSessionDurations(),
            apiClient.fetchExerciseRoutines(),
            apiClient.fetchExerciseRestrictions(),
            apiClient.fetchAvailableTools(),
            apiClient.fetchPartTags(),
        ])
            .then(([fetchedGenders, fetchedPrefectures, fetchedActivityLevelOptions, fetchedWorryOptions, fetchedInterestOptions, fetchedSessionDurations, fetchedExerciseRoutines, fetchedExerciseRestrictions, fetchedAvailableTools, fetchedPartTags,]) => {
            setGenderOptions(fetchedGenders);
            setPrefectureOptions(fetchedPrefectures);
            setActivityLevelOptions(fetchedActivityLevelOptions.map((activityLevel) => {
                return { name: activityLevel.name, value: activityLevel.id };
            }));
            setWorryOptions(fetchedWorryOptions);
            setInterestOptions(fetchedInterestOptions);
            setSessionDurations(fetchedSessionDurations);
            setExerciseRoutines(fetchedExerciseRoutines);
            setExerciseRestrictions(fetchedExerciseRestrictions);
            setAvailableTools(fetchedAvailableTools);
            setPartTags(fetchedPartTags);
        })
            .finally(() => {
            setIsLoading(false);
        });
    }, []);
    useEffect(() => {
        setSaveButtonClickable(changedInputValue() && (isValidateRealtime ? validate(false) : true));
    }, [
        imgSrc,
        userName,
        birthday,
        gender,
        prefecture,
        weight,
        height,
        activityLevelType,
        worries,
        interests,
        sessionDurationType,
        exerciseRoutineType,
        targetBodyPartTagIds,
        exerciseRestrictionIds,
        availableToolIds,
    ]);
    const validate = (showAlert) => {
        const errorMessages = {
            userName: '',
            birthday: '',
            gender: '',
            height: '',
            weight: '',
            activityLevelType: '',
            worries: '',
            interests: '',
            sessionDurationType: '',
            exerciseRoutineType: '',
            targetBodyPartTagIds: '',
            exerciseRestrictionIds: '',
            availableToolIds: '',
        };
        if (userName.length === 0) {
            errorMessages.userName = 'ニックネームを入力してください';
        }
        const format = 'YYYY-MM-DD';
        if (birthday.length === 0 || !validateDate(birthday, format)) {
            errorMessages.birthday = '誕生日を入力してください';
        }
        if (gender === '0') {
            errorMessages.gender = '性別を入力してください';
        }
        if (!height || Number(height) < 1) {
            errorMessages.height = '身長を入力してください';
        }
        if (!weight || Number(weight) < 1) {
            errorMessages.weight = '体重を入力してください';
        }
        if (!activityLevelType) {
            errorMessages.activityLevelType = '普段の運動量を選択してください';
        }
        // 居住地以外は必須。複数選択は1つ以上の選択を必須とする
        if (worries.length === 0) {
            errorMessages.worries = '目的を選択してください';
        }
        if (interests.length === 0) {
            errorMessages.interests = '興味を選択してください';
        }
        if (!sessionDurationType) {
            errorMessages.sessionDurationType = '1回の運動時間を選択してください';
        }
        if (!exerciseRoutineType) {
            errorMessages.exerciseRoutineType = '運動習慣を選択してください';
        }
        if (targetBodyPartTagIds.length === 0) {
            errorMessages.targetBodyPartTagIds = '気になる部位を選択してください';
        }
        if (exerciseRestrictionIds.length === 0) {
            errorMessages.exerciseRestrictionIds = '運動制限を選択してください';
        }
        if (availableToolIds.length === 0) {
            errorMessages.availableToolIds = '使えるツールを選択してください';
        }
        setValidationErrorMessages(errorMessages);
        const hasError = !!Object.values(errorMessages).join('');
        if (hasError) {
            setIsValidateRealtime(true);
            if (showAlert) {
                alertPresenter.showError(null, '入力内容を確認してください');
            }
        }
        return !hasError;
    };
    const changeUserName = (event) => {
        if (profile.validateUserName(event.target.value)) {
            setUserName(event.target.value);
        }
    };
    const changeGender = (event) => {
        setGender(event.target.value.toString());
    };
    const changePrefecture = (event) => {
        setPrefecture(event.target.value);
    };
    const changeWeight = (event) => {
        const value = UserWeight.formatWeight(event.target.value);
        setWeight(value);
    };
    const changeHeight = (event) => {
        if (profile.validateHeight(Number(event.target.value))) {
            setHeight(event.target.value);
        }
    };
    const onClickExerciseRestriction = (value) => {
        setExerciseRestrictionIds((prev) => {
            if (prev.includes(value)) {
                return prev.filter((v) => v !== value);
            }
            const row = exerciseRestrictions.find((r) => String(r.id) === value);
            if (!row) {
                return prev;
            }
            if (row.selectedUnique) {
                return [value];
            }
            return [
                ...prev.filter((id) => {
                    const r = exerciseRestrictions.find((x) => String(x.id) === id);
                    return r && !r.selectedUnique;
                }),
                value,
            ];
        });
    };
    const onClickExerciseTool = (value) => {
        setAvailableToolIds((prev) => {
            if (prev.includes(value)) {
                return prev.filter((v) => v !== value);
            }
            const row = availableTools.find((r) => String(r.id) === value);
            if (!row) {
                return prev;
            }
            if (row.selectedUnique) {
                return [value];
            }
            return [
                ...prev.filter((id) => {
                    const r = availableTools.find((x) => String(x.id) === id);
                    return r && !r.selectedUnique;
                }),
                value,
            ];
        });
    };
    const changedInputValue = () => {
        return (imgSrc !== profile.pictureSrc ||
            userName !== profile.userName ||
            birthday !== profile.birthday ||
            gender !== profile.gender.toString() ||
            prefecture !== profile.prefecture ||
            weight !== (!profile.weight ? '' : profile.weight.toString()) ||
            height !== (!profile.height ? '' : profile.height.toString()) ||
            activityLevelType !== (profile.activityLevel.id || null) ||
            !checkSameArray(worries, profile.worriesIdsToString) ||
            !checkSameArray(interests, profile.interestsIdsToString) ||
            sessionDurationType !== profile.sessionDurationType ||
            exerciseRoutineType !== profile.exerciseRoutineType ||
            !checkSameArray(targetBodyPartTagIds, profile.targetBodyPartTagIdsToString) ||
            !checkSameArray(exerciseRestrictionIds, profile.exerciseRestrictionIdsToString) ||
            !checkSameArray(availableToolIds, profile.availableToolIdsToString));
    };
    const onClickCancel = () => {
        setItemKey(SettingItemKeys.mypage);
        window.scrollTo(0, 0);
    };
    const selectFile = (selectedFile) => {
        setFile(selectedFile);
        setImgSrc(window.URL.createObjectURL(selectedFile));
    };
    // 更新対象取得
    const buildUpdateItems = () => {
        return {
            userName,
            birthday,
            gender: Number(gender),
            prefecture,
            height: Number(height),
            weight: Number(weight),
            activityLevelType: activityLevelType,
            worryIds: worries.map((str) => parseInt(str, 10)),
            interestIds: interests.map((str) => parseInt(str, 10)),
            sessionDurationType: sessionDurationType,
            exerciseRoutineType: exerciseRoutineType,
            targetBodyPartTagIds: targetBodyPartTagIds.map((s) => parseInt(s, 10)),
            exerciseRestrictionIds: exerciseRestrictionIds.map((s) => parseInt(s, 10)),
            availableToolIds: availableToolIds.map((s) => parseInt(s, 10)),
        };
    };
    const onClickSave = () => __awaiter(void 0, void 0, void 0, function* () {
        setSaveButtonClickable(true);
        if (!validate(true)) {
            setSaveButtonClickable(false);
            return;
        }
        if (file != null) {
            yield apiClient.uploadProfilePicture(file);
        }
        const profile = yield apiClient.patchMypageProfile(buildUpdateItems());
        setProfile(profile);
        tracker.trackMypageProfileUpdate(profile);
        if (profile.showGoalAchievedDialog) {
            setIsShowGoalAchievedDialog(true);
        }
        else {
            navigateToMyPage();
        }
    });
    const onClickSetNewGoal = () => {
        navigate(`${routes.GOAL_MATCHING_ASSESSMENT.compile()}?${GoalMatchingAssessmentPageQuery.change}=1`);
    };
    const navigateToMyPage = () => {
        setItemKey(SettingItemKeys.mypage);
        navigate(`${routes.SETTING.compile()}?key=${SettingItemKeys.mypage}`);
        window.scrollTo(0, 0);
    };
    if (isLoading) {
        return React.createElement(PageLoading, null);
    }
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement(SelectProfilePicture, { submit: selectFile, imgSrc: imgSrc, clipFileSrc: clipFileSrc, setClipFileSrc: setClipFileSrc }),
        React.createElement("div", { className: css(styles.section) },
            React.createElement(Input, { type: "text", value: userName, placeholder: "15\u6587\u5B57\u4EE5\u5185", dataTest: "name", onChange: changeUserName, label: "\u30CB\u30C3\u30AF\u30CD\u30FC\u30E0", required: true, hasValidationError: !!validationErrorMessages.userName, validationErrorMessage: validationErrorMessages.userName }),
            React.createElement(DateSelectForm, { label: "\u8A95\u751F\u65E5", required: true, currentValue: birthday, setCurrentValue: setBirthday, hasValidationError: !!validationErrorMessages.birthday, validationErrorMessage: validationErrorMessages.birthday }),
            React.createElement(Select, { selectOptions: genderOptions, label: "\u6027\u5225", defaultValue: gender.toString(), onChange: changeGender, containerClassObject: styles.selectContainer, displayIcon: true, placeholder: "\u6027\u5225\u3092\u8FFD\u52A0", placeholderValue: "0", required: true, hasValidationError: !!validationErrorMessages.gender, validationErrorMessage: validationErrorMessages.gender }),
            React.createElement(Select, { selectOptions: prefectureOptions, label: "\u5C45\u4F4F\u5730", defaultValue: prefecture, onChange: changePrefecture, containerClassObject: styles.selectContainer, displayIcon: true, placeholder: "\u5C45\u4F4F\u5730\u3092\u8FFD\u52A0", placeholderValue: "" })),
        React.createElement("div", { className: css(styles.section) },
            React.createElement(Input, { type: "number", value: height, placeholder: "\u8EAB\u9577\u3092\u8FFD\u52A0", dataTest: "height", hideSpinner: true, onChange: changeHeight, label: "\u8EAB\u9577", unitLabel: "cm", required: true, hasValidationError: !!validationErrorMessages.height, validationErrorMessage: validationErrorMessages.height }),
            React.createElement(Input, { type: "number", value: weight, placeholder: "\u4F53\u91CD\u3092\u8FFD\u52A0", dataTest: "weight", hideSpinner: true, onChange: changeWeight, label: "\u4F53\u91CD", unitLabel: "kg", required: true, hasValidationError: !!validationErrorMessages.weight, validationErrorMessage: validationErrorMessages.weight })),
        React.createElement("div", { className: css(styles.section) },
            React.createElement(InputButtonTypeRadioButton, { items: activityLevelOptions, currentValue: activityLevelType, label: '普段の運動量', setCurrentValue: (v) => setActivityLevelType(v !== null && v !== void 0 ? v : ''), required: true, hasValidationError: !!validationErrorMessages.activityLevelType, validationErrorMessage: validationErrorMessages.activityLevelType }),
            React.createElement(InputButtonTypeCheckbox, { items: worryOptions, currentValue: worries, label: '目的', setCurrentValue: setWorries, required: true, hasValidationError: !!validationErrorMessages.worries, validationErrorMessage: validationErrorMessages.worries }),
            React.createElement(InputButtonTypeCheckbox, { items: interestOptions, currentValue: interests, label: '興味', setCurrentValue: setInterests, isHalfTile: true, required: true, hasValidationError: !!validationErrorMessages.interests, validationErrorMessage: validationErrorMessages.interests })),
        React.createElement("div", { className: css(styles.section) },
            React.createElement(InputButtonTypeRadioButton, { label: '1回の運動時間', items: sessionItems, currentValue: sessionDurationType, isHalfTile: true, setCurrentValue: (v) => setSessionDurationType(v !== null && v !== void 0 ? v : ''), required: true, hasValidationError: !!validationErrorMessages.sessionDurationType, validationErrorMessage: validationErrorMessages.sessionDurationType }),
            React.createElement(InputButtonTypeRadioButton, { label: '運動習慣', items: routineItems, currentValue: exerciseRoutineType, setCurrentValue: (v) => setExerciseRoutineType(v !== null && v !== void 0 ? v : ''), required: true, hasValidationError: !!validationErrorMessages.exerciseRoutineType, validationErrorMessage: validationErrorMessages.exerciseRoutineType }),
            React.createElement(InputButtonTypeCheckbox, { label: '気になる部位', items: partItems, currentValue: targetBodyPartTagIds, isHalfTile: true, setCurrentValue: setTargetBodyPartTagIds, required: true, hasValidationError: !!validationErrorMessages.targetBodyPartTagIds, validationErrorMessage: validationErrorMessages.targetBodyPartTagIds }),
            React.createElement(InputButtonTypeCheckbox, { label: '運動制限', items: restrictionItems, currentValue: exerciseRestrictionIds, isHalfTile: true, setCurrentValue: setExerciseRestrictionIds, onClickButton: onClickExerciseRestriction, required: true, hasValidationError: !!validationErrorMessages.exerciseRestrictionIds, validationErrorMessage: validationErrorMessages.exerciseRestrictionIds }),
            React.createElement(InputButtonTypeCheckbox, { label: '使えるツール', items: toolItems, currentValue: availableToolIds, isHalfTile: true, setCurrentValue: setAvailableToolIds, onClickButton: onClickExerciseTool, required: true, hasValidationError: !!validationErrorMessages.availableToolIds, validationErrorMessage: validationErrorMessages.availableToolIds })),
        React.createElement(FixedFooterUpdateButton, { onCancelClick: onClickCancel, onSaveClick: onClickSave, disabeled: !saveButtonClickable }),
        isShowGoalAchievedDialog && (React.createElement(WeightGoalAchievedDialog, { onClickSetNewGoal: onClickSetNewGoal, onClickCancel: navigateToMyPage }))));
};
const styles = StyleSheet.create({
    container: {
        width: 315,
    },
    section: {
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        marginBottom: 40,
    },
    selectContainer: {
        display: 'block',
    },
});
